module.exports = __webpack_public_path__ + "static/media/panelUsuario.d5976b04.png";